import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/Mbaitu-Logo.jpg";

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      variant="light"
      fixed="top"
      className="navbar-main shadow-sm border-bottom"
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold text-dark d-flex align-items-center">
          <img src={logo} alt="Mbaitu USA Logo" width="40" height="40" className="me-2 rounded-circle" />
          Mbaitu USA
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" className={`me-3 ${location.pathname === "/" ? "active fw-bold" : "text-dark fw-semibold"}`} onClick={() => setExpanded(false)}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className={`me-3 ${location.pathname === "/about" ? "active fw-bold" : "text-dark fw-semibold"}`} onClick={() => setExpanded(false)}>
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/events" className={`me-3 ${location.pathname === "/events" ? "active fw-bold" : "text-dark fw-semibold"}`} onClick={() => setExpanded(false)}>
              Events
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className={`me-3 ${location.pathname === "/contact" ? "active fw-bold" : "text-dark fw-semibold"}`} onClick={() => setExpanded(false)}>
              Contact
            </Nav.Link>

            {user && (
              <Nav.Link as={Link} to="/financials" className={`me-3 ${location.pathname === "/financials" ? "active fw-bold" : "text-dark fw-semibold"}`} onClick={() => setExpanded(false)}>
                Financials
              </Nav.Link>
            )}

            {user?.role === "admin" && (
              <Nav.Link
                as={Link}
                to="/admin-dashboard"
                className="fw-semibold text-danger me-2 nav-link-admin"
                onClick={() => setExpanded(false)}
              >
                Admin
              </Nav.Link>
            )}

            {user ? (
              <Button variant="outline-danger" className="ms-3" onClick={() => { logout(); navigate("/"); setExpanded(false); }}>
                Logout
              </Button>
            ) : (
              <Button as={Link} to="/login" variant="dark" className="ms-3" onClick={() => setExpanded(false)}>
                Login
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
